<template>
    <div>
       <form @submit.prevent="addAttribute(project.id)" class="col-12 d-flex">
            <select class="form-control mb-3" @change="selectProduct($event.target.value)">
            <option>متریالی را انتخاب کنید!</option>
            <option v-for="(material, index) in materials" :key="index" :value="material.id">{{material.name}}</option>
            </select>
            <button class="btn btn-primary btn-floating ml-2" type="submit"><i class="ti-plus"></i></button>
        </form>
        <table class="table table-bordered table-sm table-responsive" style="overflow-x:scroll; width:100%;">
            <thead>
            <tr>
                <th>ردیف</th>
                <th >نام</th>
                <th v-for="(attribute, indexAttr) in project.attributes" :key="indexAttr">
                {{attribute.material.name}}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
               <td>{{counter}}</td>
                <td>
                   <router-link class="btn btn-outline-primary"
                    :to="{
                      name:'projects.show',
                      params: { id: project.id}
                      }">
                     {{project.name}}
                  </router-link>
                  <br>
                  <p v-if="project.manager.name!='مدیری انتخاب نشده'">
                    مدیرپروژه:
                    <br>
                    {{project.manager.name }}
                    <br>
                    {{ project.manager.phone }}
                  </p>
                </td>
                <td v-for="(attribute, indexAttrDetail) in project.attributes" :key="indexAttrDetail">
                <!-- <p> {{attribute.material.name}}</p> -->
                <installer :installers="installers" :attr="attribute"></installer>
                <input type="text" class="form-control" :value="attribute.installer.name" disabled>
                <status :statuses="statuses" :attr="attribute"></status>
                <div v-if="attribute.detail">
                    <textarea name="description" cols="10" rows="3"
                    class="form-control" v-text="attribute.detail.description" @change="changeDescription(attribute.id, $event.target.value)">
                    </textarea>
                </div>
                <div v-else>
                    <textarea name="description" cols="10" rows="3"
                    class="form-control" @change="changeDescription(attribute.id, $event.target.value)">
                    </textarea>
                </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import status from '@/components/project/material/Status.vue'
import installer from '@/components/project/material/Installer.vue'
export default {
  props: ['project', 'materials', 'statuses', 'installers', 'attr', 'counter'],
  name: 'board',
  data () {
    return {
      product: null
    }
  },
  components: {
    status,
    installer
  },
  methods: {
    selectProduct (val) {
      this.product = val
    },
    changeDescription (id, value) {
      this.$send.submit('post', 'api/project/' + id + '/change/description', { description: value })
    },
    addAttribute (projectId) {
      if (this.product != null) {
        this.$send.submit('get', 'api/project/' + projectId + '/' + this.product)
          .then(response => {
            console.log(response)
            // this.data[num] = response
            this.project.attributes = response.attributes
          })
      } else {
        // eslint-disable-next-line no-undef
        swal(
          'خطا!',
          'ابتدا متریالی را انتخاب کنید!',
          'warning', {
            button: 'باشه'
          })
      }
    }
  }
}
</script>
